<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          お知らせ
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Board</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">お知らせ</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> お知らせ
      </template> -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="5">
            From
            <b-form >
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="5">
            To
            <b-form >
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="12">
            <b-form class="m-2"> <span>カテゴリー</span> </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form class="m-2">
            <label for="webcastle">
              <input type="radio" value="webcastle" id="webcastle" v-model="so.opt.type" @click="so.sk='type'">  WEBCastle</label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wsfinder">
              <input type="radio" value="wsfinder" id="wsfinder" v-model="so.opt.type" @click="so.sk='type'"> WSFinder</label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wmds">
              <input type="radio" value="wmds" id="wmds" v-model="so.opt.type" @click="so.sk='type'"> WMDS</label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wfdetector">
              <input type="radio" value="wfdetector" id="wfdetector" v-model="so.opt.type" @click="so.sk='type'"> WFDetector</label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="release">
              <input type="radio" value="release" id="release" v-model="so.opt.type" @click="so.sk='type'"> リリース</label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="etc">
              <input type="radio" value="etc" id="etc" v-model="so.opt.type" @click="so.sk='type'"> ETC</label>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>タイトル</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_remote_addr" v-model="so.opt.title" :placeholder="'タイピングタイプ'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>コンテンツ</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_target" v-model="so.opt.content" :placeholder="'コンテンツの入力'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>

        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh"> 検索 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="dark" @click="so.adv = false"> 閉じる </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" /> -->
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">タイトル</b-input-group-text>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 詳細検索</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <!-- <b-row>
        <b-col>
          <span class="text-danger font-weight-bold"> タイトルをクリックすると詳細情報が表示されます </span>
        </b-col>
      </b-row>
      <hr> -->

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="type" slot-scope="row">{{ codes.BOARD_TYPE[row.item.type]}}</template>
        <!-- <template slot="title" slot-scope="row">{{row.item.title}}</template> -->
        <template slot="title" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.title}}
          </a>
          <!-- <span class="font-weight-bold" @click="detail(row.item)" style="cursor: pointer;">{{row.item.title}}</span> -->
        </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">詳細</b-btn>
        </template>
      </b-table>

      <hr>

      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"  />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
